import { api } from "@/config/api";
import type { AxiosError } from "axios";
import { WelcomeFailReason } from "ipctg-inflow-types/InFlowEnums";
import type { ParkWelcomePOSTErrorResponse, ParkWelcomePOSTRequest, ParkWelcomePOSTSuccessResponse } from "ipctg-inflow-types/InFlowParkAPI";

export const fetchWelcomeData = async (requestData: ParkWelcomePOSTRequest): Promise<ParkWelcomePOSTSuccessResponse> => {
  try {
    const response = await api.post<ParkWelcomePOSTSuccessResponse>("/welcome", requestData);
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError<ParkWelcomePOSTErrorResponse>;
    throw axiosError.response?.data ?? { failReason: WelcomeFailReason };
  }
};
